import { useShallow } from 'zustand/react/shallow';

import { useAddendum } from '@/core/addendum';
import { useFinalImpressionsFormStore } from '@/store';

import { resolveAddendumSession } from '../../final-impression/final-impressions/addendum-field/addendum-field.util';

export function useAddendumTextForValidation() {
  const { activeSession, addenda } = useAddendum();
  const { addendum: formAddendum, addendumUuid: formAddendumUuid } = useFinalImpressionsFormStore(
    useShallow((state) => ({
      addendum: state.addendum,
      addendumUuid: state.addendumUuid,
    })),
  );

  const activeAddendumUuid = activeSession?.status === 'active' ? activeSession.addendumUuid : null;

  if (activeAddendumUuid && formAddendumUuid === activeAddendumUuid) {
    return formAddendum ?? '';
  }

  return resolveAddendumSession({ activeSession, addenda }).addendumText;
}
